function createLinkElement(dataString: string, filename = "data.csv") {
  const link = document.createElement("a");
  link.setAttribute("href", `data:text/csv;charset=utf-8,${encodeURIComponent(dataString)}`);
  link.setAttribute("download", filename);
  return link;
}

export function triggerCsvDownload(dataString: string, filename = "data.csv") {
  const link = createLinkElement(dataString, filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function toCsvString(headers: string[], data: string[][]): string {
  return headers.join(",") + "\n" + data.map((row) => row.join(",")).join("\n");
}

// CSV cells beginning with one of these characters can be interpreted as a
// formula by spreadsheet apps (Excel / Google Sheets), enabling CSV injection.
const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

/**
 * Neutralise CSV / formula injection: a cell that opens with a formula-trigger
 * character (`= + - @`, tab or carriage return) is prefixed with a single quote,
 * which spreadsheets treat as a literal-text marker. Expects a string.
 */
export function sanitizeCsvValue(value: string): string {
  return FORMULA_TRIGGER.test(value) ? `'${value}` : value;
}

/**
 * Quote a cell per RFC 4180 when it contains a double-quote, comma or line break.
 * Carriage returns (`\r`) are quoted too — left bare they can be treated as a
 * record terminator and split one row across several lines.
 */
export function escapeCsvValue(value: string): string {
  return /[",\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

/**
 * Canonical secure encoding for a single CSV cell: null-safe, then injection-
 * neutralised, then RFC-4180 quoted. Prefer this over hand-rolling escaping so
 * the security-sensitive logic lives in one place.
 */
export function escapeCsvCell(value: unknown): string {
  if (value == null) {
    return "";
  }
  return escapeCsvValue(sanitizeCsvValue(String(value)));
}
